import _Abstract from "system/abstract"

export default class Component_HeaderMobile extends _Abstract {

  constructor(el, options) {
    super(el, $.extend(true, {
    }, options), 'component')
     this.bindEvents()
  }

	bindEvents()
	{
    this.$el.find(".c-header__mobile-close-sub-nav").click((e) => this.onMobileCloseSubNav(e));
    this.$el.find(".c-header__mobile-menu-toggle").click((e) => this.onMobileMenuToggled(e));
    this.$el.find(".b-header__top-nav-list > li > a").click((e) => this.onListItemAClicked(e));
    this.$el.find(".c-search-input .c-search-input--input").focus((e) => this.onSearchInputFocused(e));
    this.$el.find(".c-search-input form").submit((e) => this.onSearchFormSubmitted(e));


    $(window).resize(function (event) {
      if($(this).width() < 350) {
        $('.b-header__top-nav-list.-countryselection').addClass('-pt17')
      } else {
        if($('.b-header__top-nav-list.-countryselection').hasClass('-pt17'))
        {
          $('.b-header__top-nav-list.-countryselection').removeClass('-pt17')
        }
      }
    });
  }


  
  onMobileCloseSubNav(_mouseEvent)
  {
    this.$el.find(".c-search-input--input").val("");
    this.$el.removeClass("-search-input-focused");
    this.$el.removeClass("-has-search-results");
    this.$el.removeClass("-child-nav-li-expanded");
    this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
    _mouseEvent.preventDefault();
  }


  onMobileMenuToggled(_mouseEvent)
  {
    var $clickedTarget = $(_mouseEvent.currentTarget);

    if(this.$el.hasClass("-expanded"))
    {
      this.$el.removeClass("-expanded");
      this.$el.removeClass("-search-input-focused");
    }
    else
    {
      this.$el.addClass("-expanded");  
    }

    _mouseEvent.preventDefault();
  }

  onListItemAClicked(_mouseEvent,_bRemoveClassEnabled)
  {
    if(typeof _bRemoveClassEnabled === "undefined")
    {
      _bRemoveClassEnabled = true;
    }

    var $currentTarget = $(_mouseEvent.currentTarget);
    var $currentTargetParent = $currentTarget.parent();
    var $currentTargetUL = $currentTargetParent.find("> ul");
    if(!$currentTargetUL.length)
    {
      return;
    }
    _mouseEvent.preventDefault();
    var currentTargetIsExpanded = _bRemoveClassEnabled ? $currentTargetParent.hasClass("-expanded") : false;
    this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");

    if(currentTargetIsExpanded)
    {
      if(_bRemoveClassEnabled)
      {
        $currentTargetParent.removeClass("-expanded");
      }
    }
    else
    {
      $currentTargetParent.addClass("-expanded");
    }

    if(this.$el.find(".b-header__top-nav-list > li.-expanded").length)
    {
      this.$el.addClass("-child-nav-li-expanded");
    }
    else
    {
      if(_bRemoveClassEnabled)
      {
        this.$el.removeClass("-child-nav-li-expanded");
        
      }
    }

  }


  onMouseLeaveHeader(_mouseEvent)
  {
      this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
      this.$el.removeClass("-child-nav-li-expanded");
  }

  onSearchInputFocused(_mouseEvent)
  {
    $(window).scrollTop(0);
    this.$el.addClass("-search-input-focused");

  }

  onSearchFormSubmitted(_formSubmitEvent)
  {
    _formSubmitEvent.preventDefault();
    _formSubmitEvent.stopPropagation();

    this.$el.addClass('-has-search-results');

  }

}



/** WEBPACK FOOTER **
 ** ./components/header-mobile.js
 **/